<div class="container-fluid font-color-navy container-shadow">
  <span *ngIf="isListloading" class="justify-content-center">
    <app-loading [displayeMessage]="true"></app-loading>
  </span>

  <ng-container *ngIf="!isEditable">
    <div class="button-row float-right">
      <span *ngIf="isListloading==false">
        <app-refresh (click)="ngOnInit()" [buttonDisplay]="true"></app-refresh>
      </span>
      <span *ngIf="isListloading==true">
        <app-refresh [buttonDisplay]="false"></app-refresh>
      </span>
      <button style="float:right;" mat-icon-button matTooltip="Edit Reviewer" (click)="onEditClick()" [disabled]="!canModify" [ngClass]="canModify?'font-color-orange':'color-disabled'" aria-label="Edit Reviewer">
        <mat-icon aria-hidden="false" aria-label="Edit Reviewer" fontIcon="edit_note"></mat-icon>
      </button>
    </div>
    <table mat-table [dataSource]="reviewersProgressList" class="mat-elevation-z8">
      <ng-container matColumnDef="reviewer">
        <th mat-header-cell *matHeaderCellDef class="mat-table-thead"> Reviewer </th>
        <td mat-cell *matCellDef="let reviewer">{{reviewer.reviewer}}</td>
      </ng-container>

      <ng-container matColumnDef="relatedScope">
        <th mat-header-cell *matHeaderCellDef class="mat-table-thead"> Related Scope </th>
        <td mat-cell *matCellDef="let reviewer"> {{reviewer.relatedScope}} </td>
      </ng-container>


      <ng-container matColumnDef="isApprover">
        <th mat-header-cell *matHeaderCellDef class="mat-table-thead"> Approver/Acceptor </th>
        <td mat-cell *matCellDef="let reviewer"><mat-slide-toggle color="blue" name="isApprover" [ngModel]="reviewer.isApprover"></mat-slide-toggle></td>
      </ng-container>

      <ng-container matColumnDef="progress">
        <th mat-header-cell *matHeaderCellDef class="mat-table-thead"> Progress </th>
        <td mat-cell *matCellDef="let reviewer">
          <ng-container *ngIf="reviewer.taskStatistics.requestType == 0">
            <span style="width:25px;border-bottom:4px solid #5cb85c;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-approved context-menu" title="{{reviewer.taskStatistics.approvedCount}} Approved"> {{reviewer.taskStatistics.approvedCount}} </span></span>
            <span style="width:25px;border-bottom:4px solid #d9534f;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-rejected context-menu" title="{{reviewer.taskStatistics.rejectedCount}} Needs more work"> {{reviewer.taskStatistics.rejectedCount}} </span></span>
            <span style="width:25px;border-bottom:4px solid #D0E4B0;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-not-relevant context-menu" title="{{reviewer.taskStatistics.notRelevantCount}} Not Relevant"> {{reviewer.taskStatistics.notRelevantCount}} </span></span>
            <span style="width:25px;border-bottom:4px solid #5bc0de;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-reviewed context-menu" title="{{reviewer.taskStatistics.reviewedCount}} Reviewed"> {{reviewer.taskStatistics.reviewedCount}} </span></span>
            <span style="width:25px;border-bottom:4px solid #777;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-pending context-menu" title="{{reviewer.taskStatistics.pendingCount}} Pending"> {{reviewer.taskStatistics.pendingCount}} </span></span>
          </ng-container>

          <ng-container *ngIf="reviewer.taskStatistics.requestType == 1">
            <span style="width:20px;border-bottom:4px solid #5cb85c;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-approved context-menu" title="{{reviewer.taskStatistics.approvedCount}} Accepted"> {{reviewer.taskStatistics.approvedCount}} </span></span>
            <span style="width:20px;border-bottom:4px solid #d9534f;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-rejected context-menu" title="{{reviewer.taskStatistics.rejectedCount}} Rejected"> {{reviewer.taskStatistics.rejectedCount}} </span></span>
            <span style="width:20px;border-bottom:4px solid #f0ad4e;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-could-not-test context-menu" title="{{reviewer.taskStatistics.couldNotTestCount}} Could Not Test"> {{reviewer.taskStatistics.couldNotTestCount}} </span></span>
            <span style="width:20px;border-bottom:4px solid #D0E4B0;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-not-relevant context-menu" title="{{reviewer.taskStatistics.notRelevantCount}} Not Relevant"> {{reviewer.taskStatistics.notRelevantCount}} </span></span>
            <span style="width:20px;border-bottom:4px solid #5bc0de;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-reviewed context-menu" title="{{reviewer.taskStatistics.reviewedCount}} Reviewed"> {{reviewer.taskStatistics.reviewedCount}} </span></span>
            <span style="width:20px;border-bottom:4px solid #777;display:inline-block;margin-right:5px;text-align:center;"><span class="tooltip-pending context-menu" title="{{reviewer.taskStatistics.pendingCount}} Pending"> {{reviewer.taskStatistics.pendingCount}} </span></span>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>
  <ng-container *ngIf="isEditable">
    <br />
    <div>
      <span matAutocompleteOrigin #reviewerOrigin="matAutocompleteOrigin">
        <mat-form-field class="form-group">
          <input type="text" placeholder="Select Reviewer" [formControl]="addReviewerControl" matInput [matAutocomplete]="autoReviewer"
                 [matAutocompleteConnectedTo]="reviewerOrigin" class="form-control" required>
          <mat-autocomplete [panelWidth]="'auto'" #autoReviewer="matAutocomplete" (optionSelected)="onAddReviewerSelected($event)">
            <mat-option *ngFor="let option of reviewersfilteredOptions | async" [value]="option.adsId">
              {{option.displayName}} ({{option.login}})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>

      <span class="font-color-orange" style="margin: 0 0 0 30px;">{{this.errorMessage}}</span>
      <span class="float-end">
        <button class="btn-new-ui-xs" style="margin: 0 20px 0 0;" (click)="onCancelClick()">Cancel</button>
        <button [ngClass]="isModified ? 'btn-new-ui-xs':'btn-new-ui-disabled'" (click)="onSaveClick()" [disabled]="!(canModify && isModified)">Save</button>
      </span>

    </div>
    <span *ngIf="isReviewerLoading">
      <app-loading [displayeMessage]="false"></app-loading>
    </span>

    <table class="table table-bordered table-striped" id="modifiedReviewers">
      <thead class="table-secondary">
        <tr>
          <th class="font-color-navy">REVIEWER</th>
          <th class="font-color-navy">RELATED SCOPE</th>
          <th class="font-color-navy">APPROVER/ACCEPTOR</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let reviewer of newReviewersList; index as i" [attr.id]="reviewer.reviewerId">
          <td>{{reviewer.reviewer}}</td>
          <td><input type="text" name="reviewer.relatedScope" class="form-control" [(ngModel)]="reviewer.relatedScope" /></td>
          <td>
            <mat-slide-toggle color="blue" name="isApprover" [(ngModel)]="reviewer.isApprover"></mat-slide-toggle>
          </td>
          <td><button id="remove{{reviewer.reviewerId}}" (click)="removeReviewer(reviewer)" [disabled]="!canModify" class="btn-new-ui-xs">Remove</button></td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
